import { PrismicRichText } from '@prismicio/react';
import { hasRichText } from '@publicss/utils';
import classNames from 'classnames';
import React from 'react';
import styled, { css } from 'styled-components';

import {
  _ExternalLink,
  PageBodyBlock_Hero_TextPrimary,
} from '../../types/prismic';
import { usePageContext } from '../providers/PageContext';
import { media } from '../styles/media';
import H1orH2 from './H1orH2';
import { Button } from './ui';
import ScrollIndicator from './ui/ScrollIndicator';

const Section = styled.section<{ url?: string }>`
  p a {
    text-decoration: underline;
  }

  .bg--blog {
    ${(props) => {
      if (props.url)
        return css`
          background: url(${props.url}) no-repeat 38% 24%;
          background-size: 125px;
          @media ${media.smUp} {
            background: url(${props.url}) no-repeat 34% 24%;
            background-size: 155px;
          }
          @media ${media.lgUp} {
            background: url(${props.url}) no-repeat 20% 55%;
            background-size: 275px;
          }
        `;
    }}
  }
`;

interface BlockHeroTextSliceProps {
  sliceIndex: number;
  slice: {
    primary: PageBodyBlock_Hero_TextPrimary;
  };
}

const BlockHeroTextSlice: React.FunctionComponent<BlockHeroTextSliceProps> = ({
  sliceIndex,
  slice: {
    primary: {
      button,
      description,
      eyebrow,
      heading,
      optional_background_element,
      button_type = 'typeform',
      button_link,
    },
  },
}) => {
  const { siteTag } = usePageContext();

  return (
    <Section url={optional_background_element.url} id="block-hero-text">
      <div className="bg--blog container pb-20 pt-16 md:pb-20 md:pt-20">
        <div className="grid sm:grid-cols-4 md:grid-cols-8 lg:grid-cols-12">
          {hasRichText(eyebrow) && (
            <div className="col-span-4 md:col-span-8 lg:grid-cols-12">
              <div className="eyebrow p5 line color--grey-4 fade-up mb-10">
                <PrismicRichText field={eyebrow.richText} />
              </div>
            </div>
          )}
          <div className="col-span-6">
            <H1orH2
              sliceIndex={sliceIndex}
              className={classNames(
                'color--primary fade-up lg-down:pb-10',
                siteTag === 'site:kitchenvalley' ? 'h2-kv' : 'h2'
              )}>
              <PrismicRichText field={heading.richText} />
            </H1orH2>
          </div>
          <div className="col-span-5">
            <div className="fade-up">
              <PrismicRichText field={description.richText} />
            </div>
            <div className="fade-up mt-12 flex items-center">
              {button_type === 'link' && (button_link as _ExternalLink)?.url ? (
                <Button fullWidth href={(button_link as _ExternalLink).url}>
                  <PrismicRichText field={button.richText} />
                </Button>
              ) : button_type === 'typeform' && button.typeform_id ? (
                <Button fullWidth typeformId={button.typeform_id}>
                  <PrismicRichText field={button.richText} />
                </Button>
              ) : (
                hasRichText(button.richText) && (
                  <Button globalTypeform fullWidth>
                    <PrismicRichText field={button.richText} />
                  </Button>
                )
              )}
            </div>
          </div>
          <ScrollIndicator />
        </div>
      </div>
    </Section>
  );
};
export default BlockHeroTextSlice;
